import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import { Grid, Button, Table, Header, Menu, Icon } from 'semantic-ui-react';

import { LoadingBar, TableForm, Pagination } from 'components/Commons';

import * as com_action from 'actions/company';
import cm from 'helpers/commons';

class NoticeList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { noticeList } = this.props.ListFn;
    noticeList();
  }

  render() {
    const { page, pagerow, noticeList, pageClick, moveToRegister, moveToDetail } = this.props.ListFn,
      { list } = this.props;

    let p_page = page,
      p_pagerow = pagerow,
      p_totalcount = 0,
      loading = '',
      tabledata = {
        header: {
          main: [
            { data: '#', textAlign: 'left' },
            { data: '제목', textAlign: 'left' },
            { data: '작성자', textAlign: 'left' },
            { data: '작성일', textAlign: 'left' },
            { data: '최근 수정일', textAlign: 'left' },
            { data: '노출', textAlign: 'left' }
          ]
        },
        body: {
          message: '회사 공지사항 내역이 존재하지 않습니다.',
          main: null
        }
      };

    if (list) {
      if (list.data) {
        const { paging, notice } = list.data;

        if (paging) {
          p_page = paging.page;
          p_pagerow = paging.pagerow;
          p_totalcount = paging.totalcount;
        }

        if (notice && notice.length > 0) {
          tabledata.body.main = notice.map((item) => {
            let title = item.title;
            if (cm.valueCheck(item.title)) {
              title = '[제목없음]';
            }

            let status = 'X';
            if (item.status === true) {
              status = 'O';
            }

            let obj = {
              clickFunc: moveToDetail,
              clickData: item.id,
              row: [
                {
                  data: item.idx,
                  textAlign: 'left'
                },
                {
                  data: title,
                  textAlign: 'left'
                },
                {
                  data: item.writer,
                  textAlign: 'left'
                },
                {
                  data: cm.yyyyMMdd(new Date(item.regdate)) + ' ' + cm.hhmmss(new Date(item.regdate)),
                  textAlign: 'left'
                },
                {
                  data: cm.yyyyMMdd(new Date(item.lastdate)) + ' ' + cm.hhmmss(new Date(item.lastdate)),
                  textAlign: 'left'
                },
                {
                  data: status
                }
              ]
            };
            return obj;
          });
        }
      } else {
        if (list.response) {
          tabledata.body.message = list.response.data.message;
        }
      }
    } else {
      loading = <LoadingBar />;
    }

    return (
      <div>
        {loading}

        <div className="top-btn button">
          <Button.Group>
            <Button inverted color="green" onClick={moveToRegister}>
              공지사항 등록하기
            </Button>
          </Button.Group>
        </div>

        <div className="table-box">
          <TableForm tabledata={tabledata} selectable="true" />
        </div>

        <div className="table-paging">
          <Pagination
            page={p_page}
            pageRow={p_pagerow}
            pageBlock={10}
            totalCount={p_totalcount}
            pageClick={pageClick}
          />
        </div>
      </div>
    );
  }
}

NoticeList.contextTypes = {
  router: PropTypes.object.isRequired
};

NoticeList = connect((state) => ({
  list: state.company.notice
}))(NoticeList);

export default NoticeList;
